import type { FC, ReactNode } from 'react';
import './styles.css';
import classNames from 'classnames';

interface Props {
  animated?: boolean;
  children: ReactNode;
  open: boolean;
}

export const SlidePane: FC<Props> = (props) => (
  <div
    className={classNames(
      'slide-pane',
      props.animated && 'slide-pane--animated',
      props.open && 'slide-pane--open',
    )}
  >
    {props.children}
  </div>
);
